module.exports = __webpack_public_path__ + "static/media/found5.87106640.png";